"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconInfoCircle = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconInfoCircle = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.25 16.5C13.25 17.1904 12.6904 17.75 12 17.75C11.3096 17.75 10.75 17.1904 10.75 16.5V11.5C10.75 10.8096 11.3096 10.25 12 10.25C12.6904 10.25 13.25 10.8096 13.25 11.5V16.5ZM12 9.25C11.3096 9.25 10.75 8.69036 10.75 8C10.75 7.30964 11.3096 6.75 12 6.75H12.01C12.7004 6.75 13.26 7.30964 13.26 8C13.26 8.69036 12.7004 9.25 12.01 9.25H12Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 8H12.01M12 16.5V11.5M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconInfoCircle = IconInfoCircle;
//# sourceMappingURL=IconInfoCircle.js.map